export const getUpgradeCtaConfig = ({ isPremium, isBartender, isBarOwner }) => {
  if (isPremium) {
    return {
      show: false,
      path: null,
      testId: null,
      label: null,
    };
  }

  if (isBarOwner) {
    return {
      show: true,
      path: '/pricing',
      testId: 'upgrade-free-beta-owner-btn',
      label: 'Activate Free Beta',
    };
  }

  if (isBartender) {
    return {
      show: true,
      path: '/premium',
      testId: 'upgrade-free-beta-bartender-btn',
      label: 'Activate Free Beta',
    };
  }

  return {
    show: false,
    path: null,
    testId: null,
    label: null,
  };
};

export const applyImmediatePremiumUpdate = (responseData, setUser) => {
  if (responseData?.user && typeof setUser === 'function') {
    setUser(responseData.user);
    return true;
  }
  return false;
};
